import React from 'react';
import styled from 'styled-components';
import Section from './Section';

function Home() {
    return (
        <Container>
            <Section title="Model S"
                        decription="Order Online For Touches Delivery"
                        leftbtntext="custom order"
                        rightbtntext="existing inventory"
                        backgroundImg="model-s.jpg"

            
            
            />
            <Section title="Model Y"
                        decription="Order Online For Touches Delivery"
                        leftbtntext="custom order"
                        rightbtntext="existing inventory"
                        backgroundImg="model-y.jpg"

            
            
            />
            <Section title="Model 3"
                        decription="Order Online For Touches Delivery"
                        leftbtntext="custom order"
                        rightbtntext="existing inventory"
                        backgroundImg="model-3.jpg"

            
            
            
            />
            <Section title="Model X"
                        decription="Order Online For Touches Delivery"
                        leftbtntext="custom order"
                        rightbtntext="existing inventory"
                        backgroundImg="model-x.jpg"

            
            
            />

            <Section title="Lowest cost solar Panels in America"
                        decription="Money-back guarantee"
                        leftbtntext="Order Now"
                        rightbtntext="Learn more"
                        backgroundImg="solar-panel.jpg"
            
            
            
            />
              <Section title="Solar for New Roofs"
                        decription="Solar Roof Costs Less Than a New Roof Plus Solar Panel"
                        leftbtntext="Order Now"
                        rightbtntext="Learn more"
                        backgroundImg="solar-roof.jpg"
            
            
            
            />
              <Section title="Acssesories"
                        decription=""
                        leftbtntext="Order Now"
            
                        backgroundImg="accessories.jpg"
            
            
            
            />
          

        </Container>
    )
}

export default Home

const Container = styled.div`

height: 100vh;


`
